export default "__VITE_ASSET__BvMdcFc2__"